<div class="container-fluid mt-3">
  <!-- Filters -->
  <div class="row g-3 mb-4">
    <div class="col-md-3">
      <label class="form-label">{{ "from_date" | translate }}</label>
      <p-calendar
        inputId="calendar-24h"
        [(ngModel)]="filters.fromDate"
        [readonlyInput]="true"
        [dateFormat]="date"
        (onSelect)="onFilterChange()"
        styleClass="custom-calendar"
      />
    </div>
    <div class="col-md-3">
      <label class="form-label">{{ "to_date" | translate }}</label>
      <p-calendar
        inputId="calendar-24h"
        [(ngModel)]="filters.toDate"
        [readonlyInput]="true"
        [dateFormat]="date"
        (onSelect)="onFilterChange()"
        styleClass="custom-calendar"
      />
    </div>
    <div class="col-md-4">
      <label class="form-label">{{ "search" | translate }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        [placeholder]="'Search by username' | translate"
        [(ngModel)]="filters.searchText"
        (ngModelChange)="onFilterChange()"
      />
    </div>
    <div class="col-md-2 d-flex align-items-end justify-content-end">
      <div class="export-three-dot-menu">
        <button class="export-menu-button" (click)="toggleMenu()">
          &#8942;
        </button>
        <div *ngIf="isMenuOpen" class="export-menu-dropdown">
          <button class="export-menu-item" (click)="exportToExcel()">
            Export to Excel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-responsive">
    <app-custom-table
      [listData]="sessions"
      [selectedColumns]="myColumns"
      [menuId]="menuId"
      [moduleKey]="'system_user_log'"
      [tableName]="'System User Log'"
      [totalRecords]="totalRecords"
      [page]="page"
      [pageSize]="pageSize"
      [sectionid]="menuId"
      [angularDateFormat]="angularDateFormat"
      [dateFormat]="dateFormat"
      [disableAction]="true"
      (pageChanges)="handleFilterChange($event)"
    >
    </app-custom-table>
  </div>

  <!-- Pagination -->
  <div class="d-flex justify-content-center py-3">
    <ngb-pagination
      *ngIf="sessions.length !== 0"
      class="pagination-master"
      [maxSize]="pageSize"
      [collectionSize]="totalRecords"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="handlePageChange($event)"
    >
    </ngb-pagination>
  </div>
</div>
